import { Typography } from '@mui/material';
import { memo } from 'react';

import { inventoryMinOnHandTypographySx } from '../../lib/inventoryTableRowSpec';

interface InventoryMinOnHandCellProps {
    minAllowedInStock?: number;
}

export const InventoryMinOnHandCell = memo(
    ({ minAllowedInStock = 0 }: InventoryMinOnHandCellProps) => {
        return (
            <Typography align="center" sx={inventoryMinOnHandTypographySx}>
                {minAllowedInStock || 0}
            </Typography>
        );
    },
);
